import React from 'react'
import WebriQForm from '@webriq/gatsby-webriq-form'
import './form.css'

export default () => (
  <WebriQForm
    id="online-appointment-form"
    name="Contact Us Form"
    className="contact-us pb-5"
    data-form-id="5d39408d3082f15cfb2a1987"
    data-thankyou-url="/thank-you"
  >
    <div className="form-group">
      <div className="row">
        <div className="col">
          <h1 className="send-message-header mt-5 mb-3">Send us a Message</h1>
          <span className="send-message-gray-sub-text">
            Please complete the fields below to contact a member of the Perin
            team
          </span>
        </div>
      </div>
    </div>
    <div className="form-group">
      <div className="row">
        <div className="col-md-6">
          <p htmlFor="firstname">
            First Name <span style={{ color: 'red' }}>*</span>
          </p>
          <input
            name="firstname"
            type="text"
            className="form-control"
            id="firstname"
            required
          />
        </div>
        <div className="col-md-6">
          <p htmlFor="lastname">
            Last Name<span style={{ color: 'red' }}>*</span>
          </p>
          <input
            name="lastname"
            type="text"
            className="form-control"
            id="lastname"
            required
          />
        </div>
      </div>
    </div>
    <div className="form-group">
      <div className="row">
        <div className="col-md-6">
          <p htmlFor="email">
            Email<span style={{ color: 'red' }}>*</span>
          </p>
          <input
            name="email"
            type="text"
            className="form-control"
            id="email"
            required
          />
        </div>

        <div className="col-md-6">
          <p htmlFor="Phone">
            Phone<span style={{ color: 'red' }}>*</span>
          </p>
          <input
            name="phone"
            type="text"
            className="form-control"
            id="Phone"
            required
          />
        </div>
      </div>
    </div>
    <div className="form-group">
      <div className="row">
        <div className="col">
          <p htmlFor="Phone">
            Choose Topic<span style={{ color: 'red' }}>*</span>
          </p>
          <select
            className="form-control"
            name="topic"
            id="exampleFormControlSelect1"
          >
            <option value="Electronic Evidence Collections">Electronic Evidence Collections</option>
            <option value="eDiscovery">eDiscovery</option>
            <option value="Cyber Investigations">Cyber Investigations</option>
            <option value="Paper Discovery">Paper Discovery</option>
          </select>
        </div>
      </div>
    </div>
    <div className="form-group">
      <div className="row">
        <div className="col">
          <p htmlFor="Phone">
            Subject<span style={{ color: 'red' }}>*</span>
          </p>
          <input
            name="subject"
            type="text"
            className="form-control"
            id="FirstName"
            required
          />
        </div>
      </div>
    </div>
    <div className="form-group">
      <div className="row">
        <div className="col">
          <p htmlFor="Phone">
            Message<span style={{ color: 'red' }}>*</span>
          </p>
          <textarea
            className="form-control"
            name="message"
            id="exampleFormControlTextarea1"
            rows="5"
          ></textarea>
        </div>
      </div>
      <div className="form-group text-right">
        <div className="col col-sm-6 col-md-8">
          <div className="webriq-recaptcha" />
        </div>
      </div>
      <div className="row">
        <div className="col pt-3">
          <button type="submit" className="btn-pink-contact-form">
            SEND MESSAGES
          </button>
        </div>
      </div>
    </div>
  </WebriQForm>
)
